/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useState, useEffect } from "react";
import Card from "Front/components/Card/Card.jsx";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Row, Col, FormControl, Grid } from "react-bootstrap";
import Button from "Admin/elements/CustomButton/CustomButton.jsx";
import Loading from "react-loading";
import axios from 'axios';
import moment from "moment";
import LastPrescriptionModal from "./LastPrescriptionModal";
import EmrSummaryModal from "./EmrSummaryModal";

const PatientTable = (
    { setSelectedFilters,
        selectedFilters,
        setStats,
        scrollToTop,
        setIsFilterPanelOpen,
        patientList,
        setPatientList,
        formData,
        setFormData,
        totalCount,
        setTotalCount
    }) => {

    const [sortData, setSortData] = useState(false);
    const [scroll, setScroll] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const clinicId = localStorage.getItem("clinicId")
    const [showLastPrescriptionModal, setShowLastPrescriptionModal] = useState(false)
    const [selectedRow, setSelectedRow] = useState({})
    const [showEmrSummaryModal, setShowEmrSummaryModal] = useState(false)

    function sortHandle() {
        let data = formData;
        data['direction'] = sortData ? "asc" : "desc";
        setFormData({ ...formData, ...data });
        setSortData(!sortData)
        getPatientSortList(data);
    }

    const getPatientList = async (from = {}) => {
        setIsLoading(true);
        setPatientList([])
        let sessionToken = localStorage.getItem('token');
        const appliedFilters = getTransformedFilters(selectedFilters)
        let resp = await axios({
            method: 'post',
            url: process.env.REACT_APP_PERFORMANCE_REPORT_URL + 'clinic/analytic',
            headers: {
                "Authorization": sessionToken,
                "Content-Type": "application/json"
            },
            data: {
                clinicId: clinicId,
                limit: formData.limit,
                skip: formData.page,
                filters: appliedFilters,
                // direction: formData.direction,
                // order: "createdAt",
                search: from.search,
            }
        })
        if (resp?.data?.status === "Success" && resp?.data?.statusCode) {
            setPatientList(resp.data.data);
            setTotalCount(resp.data.totalCount.patientCount);
            setStats(resp.data.totalCount)
        }
        setIsLoading(false);
    }

    const getPatientSortList = async (from = {}) => {
        let sessionToken = localStorage.getItem('token');
        let resp = await axios({
            method: 'post',
            url: process.env.REACT_APP_PERFORMANCE_REPORT_URL + 'clinic/analytic',
            headers: {
                "Authorization": sessionToken,
                "Content-Type": "application/json"
            },
            data: {
                clinicId: clinicId,
                limit: formData.limit,
                skip: formData.page,
                direction: formData.direction,
                order: "createdAt",
                search: from.search,
            }
        })
    };

    const srNo = (cell, row, enumObject, rowIndex) => {
        return rowIndex + 1 + formData.limit * formData.page;
    };

    const formatPatientName = (cell, row, enumObject, rowIndex) => {
        return `${row.firstName} ${row.lastName}`
    }

    const formatGender = (cell, row, enumObject, rowIndex) => {
        return row.gender === "Male" ? "M" : "F"
    }

    const formatRegDate = (cell, row, enumObject, rowIndex) => {
        return <span>{moment(row.createdAt).format("DD-MMM-YYYY")}</span>;
    }

    const formatLastVisitDate = (cell, row, enumObject, rowIndex) => {
        if (row?.visitData) {
            const { createdAt, lastVisitDate } = row.visitData
            const dateToUse = lastVisitDate ? lastVisitDate : createdAt
            return createdAt ? <span>{moment(dateToUse).format("DD-MMM-YYYY")}</span> : "";
        }
        return ""
    }



    const _setTableOption = () => {
        if (isLoading) {
            return (
                <Loading
                    type="bars"
                    color="#000000"
                    style={{ margin: "0px auto", width: "40px" }}
                />
            );
        } else {
            return "No data found!";
        }
    };

    const onPageChange = (page, sizePerPage) => {
        let data = formData;
        data["page"] = page - 1;
        data["limit"] = sizePerPage;
        setFormData({ ...formData, ...data });
        getPatientList(data);

        let scrollBar = 50;
        if (scroll == page && sizePerPage < scrollBar) {
            eval('$(".ps").scrollTop(0)');
        } else if (totalCount < page * sizePerPage) {
            eval('$(".ps").scrollTop(0)');
        }
        setScroll(page)
    };

    const onSearchChange = (e, field = "") => {
        let saveFormData = formData;
        saveFormData[field] = e.trimStart();
        saveFormData["page"] = 0;
        setFormData({ ...formData, ...saveFormData });
        getPatientList(saveFormData)
    };

    const rowStyleFormat = (row, rowIdx) => {
        if (row && row.visited) {
            return { backgroundColor: "#f3f1b0" };
        }
    };

    const options = {
        //onSortChange: this.onSortChange,
        clearSearch: true,
        pageStartIndex: 1, // where to start counting the pages
        paginationSize: 3, // the pagination bar size.
        prePage: "Prev", // Previous page button text
        nextPage: "Next", // Next page button text
        firstPage: "First", // First page button text
        lastPage: "Last", // Last page button text
        //paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
        paginationPosition: "bottom", // default is bottom, top and both is all available
        sizePerPage: formData.limit,
        onPageChange: onPageChange,
        page: formData.page + 1,
        noDataText: _setTableOption(),
    };



    const getTransformedFilters = (state) => {
        const filters = {
            patient: {},
            complaint: [],
            diagnosis: [],
            medicine: [],
            investigation: [],
            visit: [],
            diet: []
        };

        // Patient filters

        if (state.Patient && state.Patient.length > 0) {
            const patientFilters = state.Patient.reduce((acc, item) => {
                if (item.filter === "Gender") {
                    if (!acc.gender) acc.gender = [];
                    acc.gender.push(item.value);
                }
                if (item.filter === "StartAge") {
                    acc.ageRange = acc.ageRange || {};
                    acc.ageRange.minAge = item.value;
                }
                if (item.filter === "EndAge") {
                    acc.ageRange = acc.ageRange || {};
                    acc.ageRange.maxAge = item.value;
                }
                if (item.filter === "StarStatus") {
                    if (!acc.patientStarStatus) acc.patientStarStatus = [];
                    acc.patientStarStatus.push(item._id);
                }
                if (item.filter === "PatientType") {
                    if (!acc.patientType) acc.patientType = [];
                    acc.patientType.push(item.value);
                }
                if (item.filter === "BmiRange") {
                    if (!acc.bmiRange) acc.bmiRange = [];
                    acc.bmiRange.push(getBmiRangeValue(item.value));
                }
                return acc;
            }, {});

            filters.patient = patientFilters;
        }

        // Complaint filters
        if (state.Complaint && state.Complaint.length > 0) {
            filters.complaint = state.Complaint.map(item => item.id);
        }

        // Diagnosis filters
        if (state.Diagnosis && state.Diagnosis.length > 0) {
            filters.diagnosis = state.Diagnosis.map(item => item.id);
        }

        // Medicine filters
        if (state.Drug && state.Drug.length > 0) {
            filters.medicine = state.Drug.map(item => item.id);
        }

        // Investigation filters (Lab tests with min and max ranges)
        if (state.LabTest && state.LabTest.length > 0) {
            filters.investigation = state.LabTest.map(item => ({
                id: item.testId,
                min: item.startRange,
                max: item.endRange || null
            }));
        }

        // Visit (using PatientType filter as an example for visit types)
        if (state.Other && state.Other.length > 0) {
            const visitFilters = state.Other.filter((ele) => ele?.filter === "visitType")
            filters.visit = visitFilters.length > 0 ? visitFilters.map((ele) => ele.value) : []

            // Diet filters
            const dietFilters = state.Other.filter((ele) => ele?.filter === "treatment")
            filters.diet = dietFilters.map(item => item?._id)
        }

        return filters;
    };

    const getBmiRangeValue = (value) => {
        switch (value) {
            case "Less than 18.5":
                return "< 18.5";
            case "BMI 18.5-24.9":
                return "18.5 - 24.9";
            case "BMI 25-29.9":
                return "25 - 29.9";
            case "BMI 30-34.9":
                return "30 - 34.9";
            case "BMI 35-39.9":
                return "35 - 39.9";
            case "Above 40 or higher":
                return "40 >=";
            default:
                return null;
        }
    };


    const formatLastPrescription = (cell, row, enumObject, rowIndex) => {
        return (
            <button
                className="view-button"
                onClick={(e) => handleLastPrescription(row, rowIndex)} // Ensure row is passed correctly
            >
                View
            </button>
        );
    };



    const handleLastPrescription = (row) => {
        setSelectedRow({ ...row })
        setShowLastPrescriptionModal(true)
    }

    const handleCloseLastPrescriptionModal = () => {
        setShowLastPrescriptionModal(false)
    }

    const formatEmrSummary = (cell, row, enumObject, rowIndex) => {
        return (
            <button
                className="view-button"
                onClick={(e) => handleEmrSummary(row, rowIndex)} // Ensure row is passed correctly
            >
                View
            </button>
        );
    };



    const handleEmrSummary = (row) => {
        setSelectedRow({ ...row })
        setShowEmrSummaryModal(true)
    }

    const handleCloseEmrSummaryModal = () => {
        setShowEmrSummaryModal(false)
    }

    const handleClearFilters = () => {
        const scrollElement = document.querySelector(".ps");
        if (scrollElement) scrollElement.scrollTop = 0;
        setFormData({ limit: 10, page: 0, direction: "" })
        setTotalCount(0)
        setSelectedFilters({})
        setPatientList([])
        setIsFilterPanelOpen(false)
    }

    return (
        <div className="main-content p-0 remove-table-padding remove-card-pb">
            <Grid fluid>
                <Row>
                    <Col md={12}>
                        <Card
                            content={
                                <div className="fresh-datatables input-view-all">
                                    <Row className="self-mx-0 pt-15">
                                        <Col md={6} className="form-group self-mb-0">
                                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                <FormControl
                                                    type="text"
                                                    autoComplete="off"
                                                    placeholder="Search here ..."
                                                    name="search"
                                                    id="search"
                                                    value={formData.search || ""}
                                                    onChange={(e) => onSearchChange(e.target.value.replace(/\s+/g, " "), "search")}
                                                    style={{ flex: 1 }}
                                                />
                                                <Button
                                                    bsStyle="primary"
                                                    onClick={() => getPatientList()}
                                                >
                                                    Search
                                                </Button>
                                                <Button className="for-clr-btn"
                                                    bsStyle="danger"
                                                    onClick={handleClearFilters}
                                                >
                                                    <i class="fa fa-times" aria-hidden="true" style={{ fontSize: "17px" }}></i>Clear All Filters
                                                </Button>
                                            </div>
                                        </Col>

                                        <Col md={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Button
                                                bsStyle="info"
                                                onClick={() => getPatientList()}
                                            >
                                                Apply Filter
                                            </Button>
                                        </Col>
                                    </Row>

                                    <div className="table-responsive self-mt-0 only-patient-th for-patient-table">
                                        <BootstrapTable
                                            deleteRow={false}
                                            key={patientList}
                                            data={patientList}
                                            search={false}
                                            multiColumnSearch={true}
                                            pagination={true}
                                            options={options}
                                            striped
                                            hover
                                            condensed
                                            scrollTop={"Bottom"}
                                            remote={true}
                                            fetchInfo={{ dataTotalSize: totalCount }}
                                            trStyle={rowStyleFormat}
                                        >
                                            <TableHeaderColumn
                                                hidden={true}
                                                tdAttr={{ "data-attr": "_id" }}
                                                dataField="_id"
                                                isKey
                                                searchable={false}
                                            >
                                                Id
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                tdAttr={{ "data-attr": "#" }}
                                                thStyle={{ width: "5%", textAlign: "center" }}
                                                tdStyle={{ width: "5%", textAlign: "center" }}
                                                dataField="sn"
                                                dataFormat={srNo}
                                            >
                                                S.No.
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                tdAttr={{ "data-attr": "title" }}
                                                thStyle={{ width: "10%", textAlign: "center" }}
                                                tdStyle={{ width: "10%", textAlign: "center" }}
                                                dataField="patientClinicId"
                                            >
                                                Patient Id
                                                {/* {
                                                    !sortData ?
                                                        <i onClick={(e) => { sortHandle() }} style={{ cursor: 'pointer' }} class="fa fa-caret-up" aria-hidden="true"></i> :
                                                        <i onClick={(e) => { sortHandle() }} style={{ cursor: 'pointer' }} class="fa fa-caret-down" aria-hidden="true"></i>
                                                } */}
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                tdAttr={{ "data-attr": "title" }}
                                                thStyle={{ width: "20%", textAlign: "center" }}
                                                tdStyle={{ width: "20%", textAlign: "center" }}
                                                dataFormat={formatPatientName}
                                            >
                                                Patient Name
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                tdAttr={{ "data-attr": "title" }}
                                                thStyle={{ width: "5%", textAlign: "center" }}
                                                tdStyle={{ width: "5%", textAlign: "center" }}
                                                dataField="age"
                                            >
                                                Age
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                tdAttr={{ "data-attr": "title" }}
                                                thStyle={{ width: "5%", textAlign: "center" }}
                                                tdStyle={{ width: "5%", textAlign: "center" }}
                                                dataField="gender"
                                                dataFormat={formatGender}
                                            >
                                                Sex
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                tdAttr={{ "data-attr": "title" }}
                                                thStyle={{ width: "10%", textAlign: "center" }}
                                                tdStyle={{ width: "10%", textAlign: "center" }}
                                                dataField="phone"
                                            >
                                                Contact
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                tdAttr={{ "data-attr": "title" }}
                                                thStyle={{ width: "10%", textAlign: "center" }}
                                                tdStyle={{ width: "10%", textAlign: "center" }}
                                                dataField="city"
                                            >
                                                City
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                tdAttr={{ "data-attr": "title" }}
                                                thStyle={{ width: "10%", textAlign: "center" }}
                                                tdStyle={{ width: "10%", textAlign: "center" }}
                                                dataFormat={formatRegDate}
                                            >
                                                Registration Date
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                                tdAttr={{ "data-attr": "title" }}
                                                thStyle={{ width: "10%", textAlign: "center" }}
                                                tdStyle={{ width: "10%", textAlign: "center" }}
                                                dataFormat={formatLastVisitDate}
                                            >
                                                Last Visit Date
                                            </TableHeaderColumn>
                                            <TableHeaderColumn dataAlign="center"
                                                thStyle={{ width: "10%", textAlign: "center" }}
                                                tdStyle={{ width: "10%", textAlign: "center" }}
                                                dataFormat={formatLastPrescription}>
                                                Last Prescription
                                            </TableHeaderColumn>
                                            <TableHeaderColumn dataAlign="center" width="10%" dataFormat={formatEmrSummary}>
                                                EMR Summary
                                            </TableHeaderColumn>
                                        </BootstrapTable>
                                    </div>
                                </div>
                            }
                        />
                    </Col>
                </Row>
            </Grid>
            {showLastPrescriptionModal &&
                <LastPrescriptionModal row={selectedRow} showModal={showLastPrescriptionModal} handleClose={handleCloseLastPrescriptionModal} />
            }
            {showEmrSummaryModal &&
                <EmrSummaryModal row={selectedRow} showModal={showEmrSummaryModal} handleClose={handleCloseEmrSummaryModal} />
            }
        </div>
    );
};

export default PatientTable;
